<template>
  <div class="d-flex px-0">
    <transition-group type="transition" name="flip-list">
      <b-card key="card-show-params" class="m-0 mr-2" body-class="d-none" v-show="!showParams">
        <template #header>
          <i class="fas fa-filter m-0" @click="showParams = true"></i>
        </template>
      </b-card>
      <b-card key="card-params" class="m-0 mr-2" v-show="showParams">
        <template #header>
          <i class="fas fa-filter" @click="showParams = false"></i>
          <strong>{{ $lang.PCI.PDR.SearchParams.Title }}</strong>
        </template>
        <b-card-body style="width: 450px;">
          <div class="d-flex flex-between">
            <div class="d-flex flex-grow-1 mr-1">
              <b-form-group :label="$lang.PCI.PDR.SearchParams.LabelStartDate" class="mb-3">
                <datepicker
                    v-model="form.dataInicio.value"
                    :required="form.dataInicio.required"
                    :state="form.dataInicio.state"
                    :format="'dd/MM/yyyy'"
                    :language="ptBR"
                    :placeholder="$lang.Common.DatePlaceholder"
                    :clear-button="true"
                    :clear-button-icon="'fas fa-times'"
                    :calendar-button="true"
                    :calendar-button-icon="'fa fa-calendar'"
                    :bootstrap-styling="true"
                    :full-month-name="true"
                    :use-utc="true">
                </datepicker>
              </b-form-group>
            </div>
            <div class="d-flex flex-grow-1">
              <b-form-group :label="$lang.PCI.PDR.SearchParams.LabelEndDate" class="mb-3">
                <datepicker
                    v-model="form.dataFim.value"
                    :required="form.dataFim.required"
                    :state="form.dataFim.state"
                    :format="'dd/MM/yyyy'"
                    :language="ptBR"
                    :placeholder="$lang.Common.DatePlaceholder"
                    :clear-button="true"
                    :clear-button-icon="'fas fa-times'"
                    :calendar-button="true"
                    :calendar-button-icon="'fa fa-calendar'"
                    :bootstrap-styling="true"
                    :full-month-name="true"
                    :use-utc="true">
                </datepicker>
              </b-form-group>
            </div>
          </div>
          <b-form-group :label="$lang.PCI.PDR.SearchParams.LabelContract" class="mb-3">
            <v-select :options="form.contratoID.options" label="descricao" :reduce="param => param.contratoID" v-model="form.contratoID.value"></v-select>
          </b-form-group>
          <b-form-group :label="$lang.PCI.PDR.SearchParams.LabelWork" class="mb-3">
            <b-form-input type="search" autocomplete="off" v-mask="['A#.####/##']" v-model="form.obraReferencia.value" style="text-align: center;"></b-form-input>
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelEmployee" class="mb-3">
            <autocomplete-z ref="employeeTypeahead"
                            iconClass="fas fa-user"
                            :serializer="s => s.codigo + ' - ' + s.nome"
                            :deboundLength="2"
                            :placeholder="$lang.Common.Buttons.Search"
                            :formField="form.funcionarioID"
                            v-on:search="onSearchEmployee"
                            v-on:changeCode="onChangeCodeEmployee"
                            v-on:hit="onLoadEmployee">
            </autocomplete-z>
          </b-form-group>
          <b-button variant="third" class="w-100 my-3" @click="onSearch">{{ $lang.Common.Buttons.Search }}</b-button>
          <b-button variant="info" class="w-100 mb-3" @click="onClear">{{ $lang.Common.Buttons.Clear }}</b-button>
        </b-card-body>
      </b-card>
    </transition-group>
    <pdr ref="pdr" class="flex-grow-1" :archivedParams="params"></pdr>
  </div>
</template>

<script>
import actionsForm from '@/shared/mixins/actionsForm'
import Pdr from './pdr.vue'
import Datepicker from 'vuejs-datepicker'
import { loading, toast } from '@/shared/utils/UIHelper'
import PCIRepository from '@/shared/http/repositories/pci/pci'
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import Form from './pdrarchived-form'
import Tools from '@/components/tools/Tools'

export default {
  name: 'PDRArchived',
  mixins: [actionsForm],
  components: {
    Pdr,
    Datepicker,
    AutocompleteZ
  },
  data () {
    return {
      showParams: true,
      data: {
        dataInicio: new Date(),
        dataFim: new Date(),
        contratoID: null,
        obraReferencia: null,
        funcionarioID: null
      },
      form: Form,
      params: {}
    }
  },
  methods: {
    onLoad () {
      this.loadContracts()
    },
    loadContracts () {
      loading.push()
      PCIRepository.GetPCIs(this.company.id)
        .then(response => {
          if (response.data.code > 0) {
            this.form.contratoID.options = response.data.data
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => loading.close())
    },
    onSearchEmployee (value) {
      loading.push()
      EmployeeRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          this.$refs.employeeTypeahead.data = response.data.data
        })
        .catch((err) => {
          console.log(err)
        }).finally(() => loading.close())
    },
    onChangeCodeEmployee (value) {
      loading.push()
      EmployeeRepository.GetByCode(this.CompanySelected, value)
        .then(response => {
          if (response.data.code > 0) {
            this.$refs.employeeTypeahead.setValue(response.data.data)
            this.onLoadEmployee(response.data.data)
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => loading.close())
    },
    onLoadEmployee (data) {
      if (data) {
        this.form.funcionarioID.value = data.id
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.employeeTypeahead) {
        this.$refs.employeeTypeahead.clear()
      }
    },
    onSearch () {
      var self = this
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        this.params = this.data
        this.params.arquivado = true
        this.$nextTick(() => {
          this.$refs.pdr.onLoad()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/pdr/pdrarchived.vue